import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { tabContent1, tabContent2 } from '@/v2/constants/pages/public-pages/how-ship-and-storage-works'
import { TabsType } from '@/v2/types'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import { useSearchParams } from 'next/navigation'
import TabsContentSection from './tabs-content-section'
import TabsToggle from './tabs-toggle'

interface HowShipAndStorageWorksTabsProps {
  tabs: TabsType[]
}

const HowShipAndStorageWorksTabs: React.FC<HowShipAndStorageWorksTabsProps> = props => {
  const { tabs } = props

  const searchParams = useSearchParams()

  const activeTabId = Number(searchParams.get('tab')) || tabs[0]?.id
  const tabsContent = activeTabId === 1 ? tabContent1 : tabContent2

  return (
    <LazyMotion features={domAnimation}>
      <m.section className='text-center landing-pages-wr section-spacing'>
        <SectionWrapper>
          <TabsToggle activeTabId={`${activeTabId}`} tabs={tabs} />
          <TabsContentSection tabs={tabsContent} />
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}

export default HowShipAndStorageWorksTabs
